// La bitácora de una venta — lógica PURA, sin React.
// Solo hitos con fecha propia; el silo no expone eventos de venta.
import type { AlertTone } from './mySalesFormat';

export interface TimelineEvent {
    /** ISO-8601 del hecho. Todo hito de esta lista tiene fecha propia; si no, no entra. */
    at: string;
    text: string;
    tone: AlertTone;
}

/** Lo que hace falta de la venta para armar su bitácora. */
export interface SaleTimelineInput {
    soldAt: string;
    storeName: string | null;
    sellerName: string | null;
    imei: string | null;
    cancelledAt: string | null;
    cancelReason: string | null;
}

/** «Venta cerrada en Tienda Limpia por Andres», sin los pedazos que la venta no guardó. */
function closingText(storeName: string | null, sellerName: string | null): string {
    const where = storeName ? ` en ${storeName}` : '';
    const who = sellerName ? ` por ${sellerName}` : '';
    return `Venta cerrada${where}${who}.`;
}

/**
 * Los hitos fechados de una venta, del más viejo al más nuevo.
 *
 * La entrega comparte el sello del cierre porque el IMEI se registra al cerrar: no tiene fecha
 * propia y darle una calculada sería exactamente lo que hace el mockup.
 */
export function buildSaleTimeline(sale: SaleTimelineInput): TimelineEvent[] {
    const events: TimelineEvent[] = [
        { at: sale.soldAt, text: closingText(sale.storeName, sale.sellerName), tone: 'info' },
    ];

    if (sale.imei) {
        events.push({
            at: sale.soldAt,
            text: `Equipo entregado con IMEI ${sale.imei} registrado.`,
            tone: 'success',
        });
    }

    if (sale.cancelledAt) {
        events.push({
            at: sale.cancelledAt,
            text: sale.cancelReason
                ? `Venta cancelada. Motivo: ${sale.cancelReason}.`
                : 'Venta cancelada. La venta no registró el motivo.',
            tone: 'danger',
        });
    }

    return [...events].sort((a, b) => a.at.localeCompare(b.at));
}
